import React, { FC, useState } from 'react'
import { Button } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { LoadingSpinnerIcon } from '@/atoms/Icons/LoadingSpinnerIcon'
import { WarningCircleIcon } from '@/atoms/Icons/WarningCircleIcon'
import { Image } from '@/atoms/Image'
import { Text } from '@/atoms/Text'
import { Modal } from '@/molecules/Modal'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  isOpen: boolean
  onAccept: () => void
  onClose: () => void
}
export const MarcusVenueWarning: FC<Props> = ({ onAccept, onClose, isOpen }) => {
  const { t } = useTranslate('tickets')
  const [clickedAccept, setClickedAccept] = useState(false)

  const onClickAccept = () => {
    setClickedAccept(true)
    onAccept()
  }

  return (
    <Modal
      backgroundScreenColor="black"
      isOpen={isOpen}
      onClose={onClose}
      panelClasses="bg-white md:min-w-[393px] !rounded-[24px] !pt-[48px] !p-6 md:!p-10 md:!pt-[64px] relative"
      transition="appear"
      className="z-50"
    >
      <FlexColumn className="gap-6 text-center md:gap-8">
        <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-core-gray-200 p-2" onClick={onClose}>
          <CloseIcon color="black" size={16} />
        </div>

        <Image
          alt="logo"
          src="https://images.angelstudios.com/image/upload/v1731549129/angel-studios/tickets/Venue%20Logos/marcus-theaters-logo.png"
          width={96}
          height={96}
          className="mx-auto h-[80px] w-[80px] rounded-[12px] md:h-[96px] md:w-[96px]"
        />

        <div className="flex flex-col gap-2 text-center">
          <div className="flex items-center justify-center gap-1">
            <WarningCircleIcon color="error-700" size={24} />
            <Text color="error-700" weight="bold" className="photon-title-md md:photon-heading-xs">
              {t('discountsUnavailable', 'Discounts Unavailable')}
            </Text>
          </div>
          <Text color="core-gray-700" className="photon-paragraph-sm md:photon-paragraph-md block">
            {t(
              'discountsUnavailableMaruc',
              'Discounts, Guild tickets, and Angel promotional codes cannot be used for showtimes at Marcus Theaters.',
            )}
          </Text>
        </div>

        <Button
          disabled={clickedAccept}
          onClick={onClickAccept}
          className="flex items-center gap-1 !rounded-[14px] !px-6 !py-3.5 !text-base md:mx-auto md:w-fit md:!px-[28px] md:!py-[17px] md:!text-lg"
          variant="black"
        >
          {clickedAccept && <LoadingSpinnerIcon size={18} color="black" />}
          {t('proceedToMarcus', 'Proceed to {{url}}', { url: 'marcustheaters.com' })}
        </Button>
      </FlexColumn>
    </Modal>
  )
}
